/* eslint-disable react-hooks/exhaustive-deps */
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import * as Yup from "yup";

import { CGStocksForm } from "..";
import { IStocksForm } from "../../../../config/interfaces";
import {
	StockFormListedInitValues,
	StocksFormSchema
} from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
	showCanvas: boolean;
	formValues: IStocksForm | null;
	handleCloseBtnPress: (StocksData: IStocksForm | null) => void;
};

const CGStocksDetailsForm: React.FC<Props> = (props: Props) => {
	const { showCanvas, handleCloseBtnPress, formValues } = props;

	const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

	const [initFormValues, setInitFormValues] = useState<IStocksForm>(StockFormListedInitValues);

	useEffect(() => {
		if (showCanvas && formValues) {
			setInitFormValues(() => cloneDeep(formValues));
		} else {
			setInitFormValues(() => cloneDeep(StockFormListedInitValues));
		}
	}, [showCanvas, formValues]);

	return (
		<>
			<Offcanvas show={showCanvas} placement="end" backdrop={true}>
				<Offcanvas.Header>
					<Offcanvas.Title>Add/Edit Stocks Details</Offcanvas.Title>
					<Button
						variant="primary"
						className="icon-only hide-offcanvas"
						onClick={() => handleCloseBtnPress(null)}
					>
						<FASvgIcon icon={faXmark} />
					</Button>
				</Offcanvas.Header>

				<Formik
					enableReinitialize={true}
					initialValues={initFormValues}
					validationSchema={Yup.object().shape({ ...StocksFormSchema })}
					onSubmit={async (values) => handleCloseBtnPress(values)}
				>
					{({ handleSubmit, submitCount, isValid, errors, validateForm }) => (
						<>
							<ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

							<Offcanvas.Body>
								<CGStocksForm />
							</Offcanvas.Body>

							<div className="offcanvas-btns">
								{!isFilingReadOnly ? (
									<Button
										variant="outline-white"
										size="sm"
										onClick={async (event) => {
											event.preventDefault();
											await validateForm();
											handleSubmit();
										}}
									>
										Save and Close
									</Button>
								) : (
									<Button
										variant="outline-white"
										size="sm"
										onClick={() => handleCloseBtnPress(null)}
									>
										Close
									</Button>
								)}
							</div>
						</>
					)}
				</Formik>
			</Offcanvas>
		</>
	);
};

export default CGStocksDetailsForm;
